import React from 'react'
import { bidUnitList } from '../../../Store'

const BidResult = ({ bidHistory, traderCode, bidGroup }) => {
    
    const getNameById = (entryUnit) => {
        const item = bidUnitList.find((item) => entryUnit == item.id)
        return item ? item.name : 'Not Found'
    }
    //===============================================
    // Css　
    //===============================================
    const container = {
        backgroundColor:'#fff',borderBottom : '1px solid #ababab',padding : '10px', width: '100%', marginBottom: '10px'
    }
    let entrySuryo;
    if (bidGroup.bidMode == 0) {
        entrySuryo = bidHistory.entrySuryoDsp;
    } else if (bidGroup.bidMode == 1) {
        entrySuryo = bidHistory.bidSuryo + '匹'
    } else if (bidGroup.bidMode == 2) {
        entrySuryo = bidHistory.bidSuryo + '箱'
    }
    return (
        
            <div style={{borderRadius : '10px', width: '100%'}}>
                <div style={container}>
                    <div style={{marginLeft:'1em'}}>
                        {
                            traderCode == bidHistory.traderCode
                            ?
                            <div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal', color:'red'}}>{`屋号：${ bidHistory.trader }(${bidHistory.traderCode})`}</div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal', color:'red'}}>{`単価：${bidHistory.tanka}円`}</div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal', color:'red'}}>{`落札：${ entrySuryo } / 備考：${bidHistory.condition}`}</div>
                            </div>
                            :
                            <div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal'}}>{`屋号：${ bidHistory.trader }(${bidHistory.traderCode})`}</div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal'}}>{`単価：${bidHistory.tanka}円`}</div>
                                <div style={{fontSize:'20px', fontWeight:'normal', textAlign:'left', fontWeight:'normal'}}>{`落札：${ entrySuryo } / 備考：${bidHistory.condition}`}</div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        
    )
  }
  
  export default BidResult